/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerListQueryResponse, IncidentScenarioControllerListQueryParams } from "../../models/incidentAgentController/IncidentScenarioControllerList";

function getIncidentScenarioControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/incident-agent/scenarios` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/scenarios}
 */
export async function incidentScenarioControllerList(params?: IncidentScenarioControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentScenarioControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentScenarioControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}